import type { RutaProd } from '../../../../runtime/rutas';
export default {ruta:'/sistema/telefono',documento:'raiz',acceso:'sesion',filas:['153'],cita:'Controllers/AccountController.cs:1474',viewBag:{sinJquery:true,claseCuerpo:'login-cuerpo'}} satisfies RutaProd;
